export const ADD_TO_PRODUCT_SELECTION = 'ADD_TO_PRODUCT_SELECTION';
export const UPDATE_PRODUCT_SELECTION = 'UPDATE_PRODUCT_SELECTION';
export const REMOVE_PRODUCT_FROM_SELECTION = 'REMOVE_PRODUCT_FROM_SELECTION';
export const REMOVE_ALL_PRODUCTS_FROM_SELECTION = 'REMOVE_ALL_PRODUCTS_FROM_SELECTION';
export const UPDATE_PRODUCT_VARIATIONS_IN_SELECTION = 'UPDATE_PRODUCT_VARIATIONS_IN_SELECTION';

export const SET_CURRENT_FEE = 'SET_CURRENT_FEE';
export const SET_CURRENT_MONTHS_SELECTION = 'SET_CURRENT_MONTHS_SELECTION';
export const RESET_ITEMS = 'RESET_ITEMS';
